// ========== FAQPage.jsx ==========
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdUnit from '../components/AdUnit';
import './StaticPages.css';

const FAQPage = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <a onClick={() => navigate('/')}> Back to Home</a>
        </nav>
      </header>
      {/* Place the AdUnit adsense component here */}
      <section className="headerAd">
      <AdUnit adSlot="8074484061" /> {/* Use your actual ad slot ID */}
      </section>
      <div className="content-container">
        <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
          <h1> Frequently Asked Questions</h1>
        </div>

        <div className="content-section">
          <h2> What is the scientific basis?</h2>
          <p>Our predictions are based on:</p>
          <ul>
            <li>Proprietary dataset: 25 years from 10,000+ random individuals</li>
            <li>Complex Neural Network architecture with multiple calculation layers</li>
            <li>Statistical correlations between past event sequences and future outcomes</li>
          </ul>
        </div>

        <div className="content-section">
          <h2> How does accuracy change over time?</h2>
          <p>Predictions are dynamic and constantly evolving. As more individuals contribute data, our dataset becomes more nuanced. The more events you input, the more accurate and acute your prediction becomes.</p>
        </div>

        <div className="content-section">
          <h2> How is my personal data handled?</h2>
          <ul>
            <li><strong>Anonymity:</strong> All data is anonymized and aggregated</li>
            <li><strong>Prediction Results NOT Stored:</strong> Output data is deleted after display</li>
            <li><strong>What We DON'T Use:</strong> Name, email, or exact date of birth for AI learning</li>
          </ul>
        </div>

        <div className="content-section">
          <h2> Are predictions guaranteed?</h2>
          <div style={{background: 'rgba(239, 68, 68, 0.1)', padding: '1.5rem', borderRadius: '10px', borderLeft: '4px solid #ef4444'}}>
            <p style={{margin: 0, fontWeight: 'bold'}}>IMPORTANT: Predictions are NOT guarantees, prophecies, or absolute facts. They are statistical insights only. All life decisions remain your responsibility.</p>
          </div>
        </div>

        <div className="cta-section">
          <button className="btn-primary" onClick={() => navigate('/login')}>Try It Yourself</button>
        </div>
      </div>
      {/* Place the AdUnit component here */}
      <AdUnit adSlot="8074484061" /> {/* Use your actual ad slot ID */}

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default FAQPage;
